import React from 'react';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { NumberField } from 'ui-toolkit';

export interface IPercentageOfLoanAmountProps {
  baseName: string;
  readOnly: boolean;
}

export const PercentageOfLoanAmount: React.FC<IPercentageOfLoanAmountProps> = ({ baseName, readOnly }) => {
  return (
    <NumberField
      name={`${baseName}.numericFeePropertyValues.${eFeePropertyNames.PercentageOfLoanAmount}`}
      label={'% of Loan Amount'}
      placeholder={'0.00'}
      mode={'default'}
      fixedDecimalScale={false}
      decimalScale={4}
      readOnly={readOnly}
    />
  );
};
